import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveTabsComponent from './js/live-tabs.component';
import LiveTabsNav from './js/live-tabs-nav';

ComponentsFactory.getInstance().define('live-tabs', LiveTabsComponent);

export {
    LiveTabsNav
};
